import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsCardBackRedesignEnabled = () => {
  const { value: isRedesignEnabled } = useFeatureGate('phx_card_back_redesign');

  const { value: isPersonalProductivityEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  return isRedesignEnabled && isPersonalProductivityEnabled;
};
